import { render } from "./Catalog.vue?vue&type=template&id=53be9126&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=53be9126&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53be9126"],['__file',"webpack-assets/vue/templates/product/catalog/Catalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53be9126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53be9126', __exports__)) {
    api.reload('53be9126', __exports__)
  }
  
  module.hot.accept("./Catalog.vue?vue&type=template&id=53be9126&scoped=true", () => {
    api.rerender('53be9126', render)
  })

}


export default __exports__